/**
 * Shared "what is RosterRx" hero paragraph — reused by AboutView and the
 * collapsible About section on RankingsView so both render identical copy
 * from one source.
 */
function RosterRxIntro() {
  return (
    <p>
      RosterRx — ask the Doctor to fix your roster. It follows you through the whole season:
      aggregate expert <strong>Pre-Draft Rankings</strong>, sharpen your strategy with an{' '}
      <strong>AI Mock Draft</strong>, get real-time <strong>In-Draft Assistance</strong> during
      your live draft, and lean on <strong>In-Season Assistance</strong> for weekly lineup,
      matchup previews, and trade decisions. Import past seasons and link opponents leagues
      across the years to build persistent profiles for everyone in your league and using
      that history to surface tendencies across drafts and seasons.
    </p>
  );
}

export default RosterRxIntro;
